<template>
  <div>
    <h3>Failed to load page...</h3>
    <p>{{ msg }}</p>
  </div>
</template>

<script>
  export default {
    name: 'Errorpage',
    props: {
      msg: String,
    }
  }
</script>

<style scoped>
  div {
    text-align: center;
  }
  h1 {
    margin-top: 2rem;
  }
  svg {
    height: 2rem;
    width: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/Errorpage.vue